import { render, staticRenderFns } from "./EditReportCustomGroup.vue?vue&type=template&id=06b9ace3"
import script from "./EditReportCustomGroup.vue?vue&type=script&lang=js"
export * from "./EditReportCustomGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports